import React from "react";

const Line = ({ color, height = 1, opacity = 1 }) => {
    return (
        <div>
            <hr style={styles.line(color, height, opacity)} />
        </div>
    );
};

const styles = {
    line: (color, height, opacity) => ({
        height: height,
        backgroundColor: color,
        opacity: opacity,
        marginTop: 10,
        marginBottom: 10,
    }),
};
export default Line;
